import { ColorRecipeModel } from '../../models/color-recipe.model';

export class EditPaintStateModel {
    colorRecipe: ColorRecipeModel;
}
